export default __webpack_public_path__ + "static/media/dog_stream_24x.7fc4a069.svg";